import { switchClasses } from '@mui/material';
import { colors } from '../constants';
const styleOverrides = {
  root: {
    width: 42,
    height: 26,
    padding: 0,
    [`&.${switchClasses.sizeSmall}`]: {
      width: 30,
      height: 20
    },
    [`&.${switchClasses.sizeSmall} .${switchClasses.switchBase}`]: {
      padding: 0,
      [`&.${switchClasses.checked}`]: {
        transform: 'translateX(10px)'
      }
    }
  },
  switchBase: {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    [`&.${switchClasses.checked}`]: {
      transform: 'translateX(16px)',
      color: '#fff',
      [`& + .${switchClasses.track}`]: {
        backgroundColor: colors.primary.main,
        opacity: 1,
        border: 0
      },
      [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
        opacity: 0.5
      }
    },
    [`&.Mui-focusVisible .${switchClasses.thumb}`]: {
      color: colors.primary.main,
      border: '6px solid #fff'
    },
    [`&.${switchClasses.disabled} .${switchClasses.thumb}`]: {
      color: colors.oriGrey[100]
    },
    [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
      opacity: 0.7
    }
  },
  thumb: {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: colors.oriGrey[200],
    opacity: 1
  }
};
const defaultProps = {
  focusVisibleClassName: '.Mui-focusVisible',
  disableRipple: true
};
export default {
  defaultProps,
  styleOverrides
};
//# sourceMappingURL=MuiSwitch.js.map